import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Instalacion`, method: 'GET', body: null, token: token})
}
